import { MainLayout } from '../../../components/Modules/Layout';
import { useParams } from 'react-router-dom';
import { Content } from 'antd/es/layout/layout';
import { Breadcrumb, Col, Row } from 'antd';
import { useQuery } from 'react-query';
import ApprovalApi from 'apis/ApprovalApi';
import { Iapprove } from 'interface/approve.interface';
import { useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import { STATUS } from 'constants/reponseStatus';
import handleError401 from 'utils/handleError401';

export default function ApprovalDetail() {
  const [approvalDetail, SetApprovalDetail] = useState<any>();
  interface Iparam {
    id: string;
  }
  const { id } = useParams<Iparam>();

  const {
    data: result,
    isLoading,
    refetch,
  } = useQuery(['getApproval'], () => ApprovalApi.getApproval(), {
    onSuccess: (response: any) => {
      if (response.status === STATUS.SUCCESS) {
        const app = response.data.filter((items: Iapprove) => {
          return items.id * 1 == +id;
        });
        SetApprovalDetail(app[0]);
        setBreadcrumb([
          { title: <a href="/department-approval">Phê duyệt</a> },
          { title: <a>{app[0].division?.name}</a> },
        ]);
        setTitle(`${app[0].division?.name}`);
      }
    },
    onError: (error: any) => {
      if (error.response.data.status === 401) {
        handleError401();
      }
    },
  });

  const ApprovalDetailItem: any = approvalDetail;
  const list_setting: Array<{
    date_end: number;
    approve_level: number;
    approve_stage: number;
  }> = ApprovalDetailItem?.list_setting || [];

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  return (
    <MainLayout isLoading={isLoading}>
      <div className="mb-4 flex flex-col gap-4">
        <Content>
          <Row className="mb-3" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={12}>
              <p className="text-xs">
                Khối phát hành:{' '}
                <span className="text-sm font-bold">
                  {ApprovalDetailItem?.division?.name}
                </span>
              </p>
            </Col>
            <Col span={12}>
              <p className="text-xs">
                Danh mục :{' '}
                <span className="text-sm font-bold">
                  {ApprovalDetailItem?.pof_type?.pof_type_name}
                </span>
              </p>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={12}>
              <p className="text-xs">
                Công ty phát hành:{' '}
                <span className="text-sm font-bold">
                  {ApprovalDetailItem?.division_id}
                </span>
              </p>
            </Col>
            <Col span={12}>
              <p className="text-xs">
                Người tạo:{' '}
                <span className="text-sm font-bold">
                  {ApprovalDetailItem?.user_created?.fullName}
                </span>
              </p>
            </Col>
          </Row>
        </Content>

        <Content>
          <div className="flex flex-col gap-5">
            <div>
              <p className="mb-1 text-sm font-bold text-[#00538F]">
                1. Phát hành danh mục
              </p>
              <Row className="ml-4">
                <Col span={6}>
                  Cấp phê duyệt <span className="mx-5">:</span>{' '}
                  <span className="text-sm font-bold">
                    {list_setting[0]?.approve_level}
                  </span>
                </Col>
                <Col span={12}>
                  Thời gian phê duyệt <span className="mx-5">:</span>{' '}
                  <span className="text-sm font-bold">
                    {list_setting[0]?.date_end} ngày
                  </span>
                </Col>
              </Row>
            </div>
            {/* <div>
              <p className="mb-1 text-sm font-bold text-[#00538F]">
                2. Chi nhánh đăng ký mẫu
              </p>
              <Row className="ml-4">
                <Col span={6}>
                  Cấp phê duyệt <span className="mx-5">:</span>{' '}
                  <span className="text-sm font-bold">
                    {list_setting[1]?.approve_level}
                  </span>
                </Col>
                <Col span={12}>
                  Thời gian phê duyệt <span className="mx-5">:</span>{' '}
                  <span className="text-sm font-bold">
                    {list_setting[1]?.date_end} ngày
                  </span>
                </Col>
              </Row>
            </div> */}
            <div>
              <p className="mb-1 text-sm font-bold text-[#00538F]">
                2. Đăng kí giỏ hàng danh mục
              </p>
              <Row className="ml-4 my-3 font-bold">
                A. Chi nhánh (Chỉ phê duyệt đơn thuộc chi nhánh)
              </Row>
              <Row className="ml-4">
                <Col span={6}>
                  Cấp phê duyệt <span className="mx-5">:</span>{' '}
                  <span className="text-sm font-bold">
                    {list_setting[2]?.approve_level}
                  </span>
                </Col>
                <Col span={12}>
                  Thời gian phê duyệt <span className="mx-5">:</span>{' '}
                  <span className="text-sm font-bold">
                    {list_setting[2]?.date_end} ngày
                  </span>
                </Col>
              </Row>
              <Row className="ml-4 my-3 font-bold">A. Hội sở</Row>
              <Row className="ml-4">
                <Col span={6}>
                  Cấp phê duyệt <span className="mx-5">:</span>{' '}
                  <span className="text-sm font-bold">
                    {list_setting[3]?.approve_level}
                  </span>
                </Col>
                <Col span={12}>
                  Thời gian phê duyệt <span className="mx-5">:</span>{' '}
                  <span className="text-sm font-bold">
                    {list_setting[3]?.date_end} ngày
                  </span>
                </Col>
              </Row>
            </div>
          </div>
        </Content>
      </div>
    </MainLayout>
  );
}
